export * from "./BettingGateway";
export * from "./BFFGateway";
export * from "./SportData";
export * from "./configuration";
export * from "./helpers";
export * from "./models";
export var mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./mocks");
}
//# sourceMappingURL=index.js.map